import { useSearchParams, useLoaderData } from 'react-router-dom';
import { IconButton, Snackbar, Snack } from '@nike/eds';
import SharedAlphabetCard from '../../components/RewriteTypoShared/AlphabetCard';
import TermItemCreate from '../../components/RewriteTypoShared/TermItemCreate';
import TermItemEdit from '../../components/RewriteTypoShared/TermItemEdit';
import DictionaryAlphabetFilter from '../../components/dictionaryAlphabetFilter';
import { extendedAlphabet } from '../../utils/alphabetHelpers';
import { useAtom } from 'jotai';
import {
  rewriteCreateModalAtom,
  rewriteUpdateMessageAtom,
  rewriteUpdateHasErrorAtom,
} from '../../atoms/rewrite';
import { isExistScope } from '../../utils/authHelpers';

export default function Rewrite() {
  const [visible, setVisible] = useAtom(rewriteCreateModalAtom);
  const [updateMsg, setUpdateMsg] = useAtom(rewriteUpdateMessageAtom);
  const [updateHasError] = useAtom(rewriteUpdateHasErrorAtom);
  const [searchParams] = useSearchParams();
  const indexKeyFromUrl = (searchParams.get('indexKey') as string) || 'ALL';

  const loaderData = useLoaderData() as { access_token: string };
  const jwt = loaderData.access_token;
  const canWrite = isExistScope('search360:rewrite:write', jwt);

  const keyList =
    indexKeyFromUrl === 'ALL' ? extendedAlphabet : [indexKeyFromUrl];

  return (
    <section className='tw-text-center tw-py-8'>
      <DictionaryAlphabetFilter
        alphabet={extendedAlphabet}
        activeKey={indexKeyFromUrl}
      />
      <div className='tw-flex tw-flex-wrap tw-items-start tw-justify-center tw-gap-8'>
        {keyList.map((l) => (
          <SharedAlphabetCard
            type='rewrite'
            indexKey={l}
            key={l}
            label={l}
            paginationSize={indexKeyFromUrl === 'ALL' ? 30 : 800}
          />
        ))}
      </div>
      {canWrite && (
        <div className='tw-fixed tw-bottom-10 tw-right-20'>
          <IconButton
            icon='Plus'
            label='New'
            onClick={() => setVisible(true)}
          />
        </div>
      )}
      <TermItemCreate type='rewrite' />
      <TermItemEdit type='rewrite' />
      <Snackbar style={{ left: '90%', top: '90%' }}>
        {updateMsg && (
          <Snack
            autoDismissDuration={5000}
            id='rewrite-update-error-notification'
            onDismiss={(id) => {
              setUpdateMsg('');
            }}
            status={updateHasError ? 'error' : 'success'}
          >
            {updateMsg}
          </Snack>
        )}
      </Snackbar>
    </section>
  );
}
